/* eslint-disable max-len */
const MAPBOX_API_TOKEN =
  "pk.eyJ1IjoibHlueC1wb2MiLCJhIjoiY2tkeWM0cHhzNGg5djJzcm9hdDM5N3oycSJ9.Qu-x_5tz4U2au5B3lKYz-w"; //"pk.eyJ1IjoiYWxleHBhbi1seW54IiwiYSI6ImNrYmg0OHNhNjAxcWoyc211bnVyMXd2djEifQ.157kbZ0kRTjiKusH7rUiHg";

/* * Map style -- Lynx-map-light * */
export const apiMapbox = {
  mapApiToken: MAPBOX_API_TOKEN,
  mapHost: "https://api.mapbox.com",
  mapAccount: "lynx-poc", // "alexpan-lynx",
  mapStyleID_Light: "ckdyh7lwn4fdu19p7j5wozini", // "ckbk33va107il1ip8y8tjdt83",
  mapStyleLabel_Light: "Lynx-map-light"
};
